/* Layout */
import AccessKeyManage from '@/views/information/accesskey/index';
import AppLIst from '@/views/generalUser/myApp/appLIst';
import MyOrders from '@/views/generalUser/myApp/myOrders';
import OverView from '@/views/generalUser/myApp/overView';
import WarningInfo from '@/views/generalUser/myApp/warningInfo';
import Layout from '@/views/layout/Layout';

const myAppRouter = {
  path: '/manage/general',
  name: 'myApp',
  props: true,
  meta: {
    title: '我的应用',
    icon: 'myApp-icon',
    role: 'seller',
    requireAuth: true
  },
  component: Layout,
  children: [
    {
      path: '',
      name: 'myOverview',
      component: OverView,
      meta: {
        title: '总览',
        icon: 'overview',
        requireAuth: true,
        role: 'seller',
        currentActive: '/manage/general'
      },
      hidden: false
    },
    {
      path: 'myapp',
      name: 'myApp',
      component: AppLIst,
      meta: {
        title: '管理应用',
        icon: 'myApp-mgt',
        requireAuth: true,
        role: 'seller',
        perms: ['User.Market.Application.Get', 'User.Market.Application.Create']
      },
      hidden: false
    },
    {
      path: 'myOrders',
      name: 'myOrders',
      component: MyOrders,
      meta: {
        title: '我的订单',
        icon: 'myApp-order',
        requireAuth: true,
        role: 'seller',
        perms: ['User.EntOrder.List', 'User.EntOrder.Create', 'User.EntOrder.Create', 'User.EntOrder.Get', 'User.EntOrder.Pay', 'User.EntOrder.Close', 'User.EntOrder.Status']
      },
      hidden: false
    },
    {
      path: 'warningInfo',
      name: 'warningInfo',
      component: WarningInfo,
      meta: {
        title: '预警信息',
        icon: 'myApp-early',
        perms: ['User.WarningNotify.List'],
        requireAuth: true,
        role: 'seller'
      },
      hidden: false
    }
  ]
};
export default myAppRouter;



// WEBPACK FOOTER //
// ./src/router/modules/myApp.js